import {Pipe, PipeTransform} from '@angular/core';
import {ServerTranslateService} from "@services/server-translate.service";

@Pipe({
  name: 'serverTranslate',
  pure: false,
  standalone: true
})
export class ServerTranslatePipe implements PipeTransform {

  constructor(private serverTranslateService: ServerTranslateService) {
  }
  transform(value: any, keyBase: string): string {
    return this.serverTranslateService.getDisplayValue(value, keyBase);
  }
}
